import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { WaIntersectionObserver } from '@ng-web-apis/intersection-observer';
import { FitType } from '../model/fit-type.enum';
import { ProgressSpinner } from 'primeng/progressspinner';
import { PSDocument } from '../model/document.interface';
import { PSDocumentPage } from '../model/document-page.interface';
import { PageImageService } from '../service/page-image.service';

export type PageIntersectionEvent = Pick<IntersectionObserverEntry, 'isIntersecting' | 'target'>;

@Component({
  selector: 'shared-dp-document-page-preview',
  imports: [WaIntersectionObserver, ProgressSpinner],
  templateUrl: './document-page-preview.component.html',
  styleUrl: './document-page-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentPagePreviewComponent {
  readonly document = input.required<PSDocument>();
  readonly page = input.required<PSDocumentPage>();
  readonly fitType = input.required<FitType>();
  readonly zoom = input.required<number>();

  readonly pageId = computed(() => this.page().id);

  pageIntersection = output<PageIntersectionEvent>();

  protected readonly pageImageService = inject(PageImageService);

  protected getImageSrc(): string | undefined {
    return this.pageImageService.getImageSrc(this.pageId())();
  }

  protected isImageLoaded() {
    return this.pageImageService.isImageLoaded(this.pageId())();
  }

  onImageLoaded(image: HTMLImageElement) {
    this.pageImageService.updateImageAspectRatio(
      this.pageId(),
      image.naturalWidth / image.naturalHeight,
    );
  }

  protected onIntersectionDetected($event: IntersectionObserverEntry[]) {
    this.pageIntersection.emit({
      isIntersecting: $event[0].isIntersecting,
      target: $event[0].target,
    });
  }
}
